import React from "react";
import AccountMappingContent from "../../components/AccountMappingContent";

function Step2() {
    return (
        <AccountMappingContent
          nextStepLink={"/xero-jobber-step3"}
        ></AccountMappingContent>
    );
}

export default Step2;
